/**
 * Buggino – Produktkarten: Farbe per Farbpunkt wählen, dann direkt „In den Warenkorb“.
 * Der Kauf selbst läuft über das bestehende Warenkorb-Drawer-Skript (form[data-ajax-cart]).
 */
(function () {
  'use strict';
  function select(dot) {
    const card = dot.closest('[data-product-card]');
    if (!card) return;
    const input = card.querySelector('[data-card-variant-input]');
    const btn = card.querySelector('[data-card-buy-btn]');
    if (!input) return;
    card.querySelectorAll('[data-card-variant]').forEach((d) => {
      d.classList.toggle('is-selected', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    input.value = dot.dataset.cardVariant;
    if (btn) btn.disabled = dot.dataset.available === 'false';
  }
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-card-variant]');
    if (dot) select(dot);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const dot = event.target.closest && event.target.closest('[data-card-variant]');
    if (!dot) return;
    event.preventDefault();
    select(dot);
  });
})();
